<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import ChatsOverview from './components/ChatsOverview.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const chatsOverviewRef = ref(null);

const onDownloadClick = () => {
  chatsOverviewRef.value?.downloadReports();
};
</script>

<template>
  <ReportHeader :header-title="$t('REPORT.HEADER')">
    <V4Button
      :label="$t('CHATS_REPORTS.DOWNLOAD')"
      icon="i-ph-file-arrow-down"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <ChatsOverview ref="chatsOverviewRef" />
</template>
